import React from 'react';

const Review = () => {
    return (
        <div>
            coming soon...
        </div>
    );
};

export default Review;